<script>
import "aframe"
import "aframe-extras"
import "aframe-svelte"
import './instanced-mesh.js'
import "aframe-environment-component"
import './particles.js';
import './displacement.js';
import { onMount } from 'svelte';
import Environment from "./Environment.svelte"
import Assets from "./Assets.svelte"
import Tree from "./Tree.svelte"
import Objects from "./Objects.svelte"
import "./src/christmas-utils.js"
function x(x,y,z){if(y)return x+' '+y+' '+z;else return x+' '+x+' '+x}


function randInt(min, max, clear) {
	let result = Math.floor(Math.random() * (max - min + 1)) + min
	let middle = (max + min) / 2
	if (clear && middle - clear < result && result < middle + clear) { return randInt(min, max, clear) }
	return result
}
// Get a random number between min (inclusive) and max (exclusive) with decimals
function randFloat(min, max, clear) {
	let result = Math.random() * (max - min) + min
	let middle = (max + min) / 2
	if (clear && middle - clear < result && result < middle + clear) { return randFloat(min, max, clear) }
	return result
}

const isInStandaloneMode=_=>(window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

function randPositions(count, range, height) {
	return new Array(count).fill(0).map(_=>[randInt(-1*range,range,range/10),height?height:1,randInt(-1*range,range,range/10)])
}
function invertedRow(count) {
	return new Array(count).fill(0).map((_,i)=>i).reverse()
}

console.log("FLOAT", randFloat(0.5,0.9))
// forEach element id AFRAME register component to MP GUN
</script>

<a-scene renderer="precision: 0.1" stats={!isInStandaloneMode()}>
	<a-camera touch></a-camera>

	<a-entity environment="groundColor: #ffffff;
						   groundColor2: #eeeeee;
						   ground: noise;
						   groundYScale: 4;
						   groundTexture: walkernoise;
						   dressing: trees;
						   dressingAmount: 50;
						   dressingColor: #ffffff;
						   dressingScale: 1;
						   lighting: distant;
						   fog: 0;
						   shadow: true
						   "/>

	<Assets/>
	<Environment color="blue"/>
	<Objects/>

<a-plane position="0 2 -7" color="red" geometry="primitive: plane; height: 15; width: 4; color: red ">
	<a-plane position="0 0 -0.3" color="red" geometry="primitive: plane; height: 15; width: 4; color: red " rotation="0 180 0"/>
	<a-entity position="-1.7 0 0" text-geometry="size:0.2;value: Every day with you is a gift." material="color: white;"/>
	<a-entity position="-1.5 0.5 0" text-geometry="size:0.2;value: Merry Christmas, Clara!" material="color: white;"/>
</a-plane>



<a-entity position="10 5 0" bear move-forward/>
<a-entity position="-15 3 5" rotation="0 50 0" cham/>
<!-- 
<a-entity id="cham" position = "0 0 0" cham instanced-mesh="capacity:100" scale="0.1 0.1 0.1"></a-entity>
<a-mixin id="cham1" instanced-mesh-member="mesh:#cham"/>
<a-entity id="cham2" position="5 2 5" rotation={"0 "+randInt(0,360)+" 0"} mixin="cham1"/>
 -->
<!-- 
<a-entity id="evergreen"
			geometry= "primitive: cone;height:0.55;radius-bottom:0.25;segments-height:1;segments-radial:9;"
			material="shader: threeColorGradientShader; topColor: #262; middleColor: #fff; bottomColor: #fff;roughness:1" 
			scale={x(3)}
			position = "10 2 0"
			instanced-mesh="capacity:100"/>
<a-mixin id="evergreen1" instanced-mesh-member="mesh:#evergreen"/>
<a-entity id="penguin2" position={x(1)} rotation={"0 "+randInt(0,360)+" 0"} mixin="evergreen1"/> -->

<!-- material="shader: threeColorGradientShader; topColor: #fff; middleColor: #262; bottomColor: #fff;" -->
<a-entity id="tree"
		  geometry="primitive:cone;height:0.55;radius-bottom:0.25;segments-height:1;segments-radial:9;"
		  scale="1 1 1"
		  material="color:#262;roughness:1;"
		  instanced-mesh="capacity:1000;"/>
{#each randPositions(130,100,2) as pos}
	{#each invertedRow(5) as n, i}
    <a-entity position={x(pos[0],randFloat(0.9,1)*i+2,pos[2])} 
			  scale={x(randFloat(0.9,1.1)*1.5*n)}
			  instanced-mesh-member="mesh:#tree"/>
    {/each}
{/each}

<a-entity id="penguin"
			penguin
			scale="0.1 0.1 0.1"
			position = "0 0 0"
			instanced-mesh="capacity:100"/>
<a-mixin id="peng1" instanced-mesh-member="mesh:#penguin"/>

{#each randPositions(50,300,2.8) as pos}
	<a-entity id="penguin2" position={x(...pos)} rotation={"0 "+randInt(0,360)+" 0"} mixin="peng1"/>
{/each}

{#each randPositions(0,0) as pos}
	<Tree position={x(...pos)}/>
{/each}
	

</a-scene>